import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CloseDropdownOnScrollDirective } from './close-dropdown-on-scroll.directive';

@NgModule({
  declarations: [CloseDropdownOnScrollDirective],
  exports: [CloseDropdownOnScrollDirective],
  imports: [
    CommonModule
  ]
})
export class CloseDropdownOnScrollModule { }
